import React from 'react'
import './OurCompanyHistory.component.scss'

const OurCompanyHistory = () => {
  return (
    <section className='our-company-history'>
      <div className='our-company-history__inner'>
        <div className='our-company-history__heading-col'>
          <h2 className='our-company-history__title'>
            <span>Our Company History</span>
          </h2>
        </div>
        <div className='our-company-history__body-col'>
          <p className='our-company-history__text'>
            <span>
              USA Benefits Group (USABG) was founded in 1988 with a simple but powerful mission: to create an
              independent insurance platform where agents could truly serve clients while building meaningful,
              sustainable careers. From its inception, USABG was built as a national brokerage dedicated to empowering
              agents with access to top-tier carriers, competitive products, and a strong support system designed for
              long-term growth
            </span>
            <span>.</span>
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurCompanyHistory
